import { getRoute } from "../client"
import type { RestStatusDto } from "../../shared/types"
export const restStatusRoute = getRoute<RestStatusDto>("/api/rooms/rest-status")
